import { render, staticRenderFns } from "./therapyCatListing.vue?vue&type=template&id=96ed0c6e&"
import script from "./therapyCatListing.vue?vue&type=script&lang=js&"
export * from "./therapyCatListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports